module.exports = __webpack_public_path__ + "img/bb_platform_12.93ee3d47.svg";